/* eslint-disable eqeqeq */
import React, { useEffect, useState, useContext } from "react";
import { format, parse, isValid as isValidDateFns } from "date-fns";
import { format as formatTz } from "date-fns-tz";
import { add } from "date-fns";
import Datetime from "react-datetime";
import * as Yup from "yup";
import axios from "axios";
import {
  Container,
  Button,
  Modal,
  Col,
  Form,
  Breadcrumb,
  Row,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { Navigate } from "react-router-dom";
import { ColumnSortingTable } from "../../components/Table.js";
import { Formik, isEmptyArray } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAuth from "../../hooks/useAuth.js";
import useLayout from "../../hooks/useLayout.js";
import { faPlus, faExclamationCircle, faSync } from "@fortawesome/free-solid-svg-icons";
import { Edit, Trash, Unlock } from "react-feather";
import { confirmAlert } from "react-confirm-alert";
import { ShowConfirm } from "../../components/Alerts.js";
import Loader from "../../components/Loader.js";
import NotyfContext from "../../contexts/NotyfContext.js";
import {
  validateDate, HelpTooltip, convertDateToDisplay, isDateAfterToday, SelectColumnFilter
} from "../../assets/functions.js";

const schema = Yup.object().shape({
  nome: Yup.string()
    .required("Campo obrigatório")
    .max("150", "Máximo de 150 caracteres"),
  email: Yup.string()
    .email("E-mail inválido")
    .required("Campo obrigatório")
    .max("150", "Máximo de 150 caracteres")
    .test("email", "E-mail já registrado", function (value) {
      if (this.parent.user_id > 0) {
        return true;
      }
      return new Promise((resolve, reject) => {
        async function checkEmail() {
          try {
            let checkData = await axios.get(
              `/api/user/checkEmail?email=${value}`
            );
            if (isEmptyArray(checkData.data.message)) {
              resolve(true);
            } else {
              resolve(false);
            }
          } catch (error) {
            console.error(error);
          }
        }
        checkEmail();
      });
    }),
  inicio_contrato_conta: Yup.string()
    .required("Campo obrigatório")
    .max("255", "Máximo de 255 caracteres")
    .test("date", "Data inválida", function (valueX) {
      if (validateDate(valueX)) {
        return true
      } else {
        return false
      }
    }),
  termino_contrato_conta: Yup.string()
    .required("Campo obrigatório")
    .max("255", "Máximo de 255 caracteres")
    .test("date", "Data inválida", function (valueX) {
      if (validateDate(valueX) && isDateAfterToday(valueX)) {
        return true
      } else {
        return false
      }
    }),
  status: Yup.number().required("Campo obrigatório").integer(),
  tipo: Yup.number().required("Campo obrigatório").integer(),
  plataforma_aplicativos: Yup.number().required("Campo obrigatório").integer(),
  plataforma_eventos: Yup.number().required("Campo obrigatório").integer(),
  aplicativos_customizacao: Yup.number().required("Campo obrigatório").integer(),
});

const tableColumns = [
  {
    Header: "Nome",
    accessor: "nome",
  },
  {
    Header: "E-mail",
    accessor: "email",
  },
  {
    Header: "Tipo de usuário",
    accessor: "tipoString",
    Filter: SelectColumnFilter,
    filter: "equals",
  },
  {
    Header: "Plataforma de Aplicativos",
    accessor: "plataforma_aplicativosString",
    Filter: SelectColumnFilter,
    filter: "equals",
  },
  {
    Header: "Plataforma de Eventos",
    accessor: "plataforma_eventosString",
    Filter: SelectColumnFilter,
    filter: "equals",
  },
  {
    Header: "Status",
    accessor: "statusString",
    Filter: SelectColumnFilter,
    filter: "equals",
  },
  {
    Header: "",
    accessor: "icons",
    disableSortBy: true,
    Filter: false,
  },
];

const formatSessionTimestamp = (value) => {
  const date = new Date(value);
  return isValidDateFns(date) ? format(date, "dd/MM/yyyy HH:mm:ss") : "Indisponível";
};

const TableUsers = () => {
  const [dataTable, setDataTable] = useState(false);
  const [updateDataTable, setDataTableUpdate] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [activeSessions, setActiveSessions] = useState([]);
  const [showSessionsModal, setShowSessionsModal] = useState(false);
  const [isLoadingSessions, setIsLoadingSessions] = useState(false);
  const [sessionsError, setSessionsError] = useState("");
  const notyf = useContext(NotyfContext);
  const { setLoading } = useLayout();
  const { tipo } = useAuth();

  //Modal data
  const [dataModal, setDataModal] = useState(false);

  //Modal handle
  const [openModals, setShowModal] = useState(false);

  function handleShow(data) {
    setDataModal(data);
    setShowModal(true);
  }

  function handleClose() {
    setDataModal(false);
    setShowModal(false);
  }

  function refreshUsers() {
    setDataTableUpdate((prevCount) => prevCount + 1);
  }

  function loadActiveSessions() {
    setIsLoadingSessions(true);
    setSessionsError("");
    return axios.get("/api/user/sessions")
      .then(function (response) {
        const sessions = response.data?.message;
        setActiveSessions(Array.isArray(sessions) ? sessions : []);
      })
      .catch(function (error) {
        setActiveSessions([]);
        setSessionsError(error.response?.data?.message || "Não foi possível carregar as sessões ativas.");
      })
      .finally(function () {
        setIsLoadingSessions(false);
      });
  }

  function handleShowSessions() {
    setShowSessionsModal(true);
    loadActiveSessions();
  }

  function handleCloseSessions() {
    setShowSessionsModal(false);
  }

  function deleteUser(user_id) {
    setLoading(true)
    axios.delete(`/api/user/${user_id}`)
      .then(function (response) {
        setLoading(false)
        setDataTableUpdate((prevCount) => prevCount + 1);
      })
      .catch(function (error) {
        setLoading(false)
        if (error.response.status === 500) {
          setLoading(false)
          notyf.open({
            type: "danger",
            message: error.response.data.message ? error.response.data.message : "Não é possível excluir esse usuário pois existem eventos ou customizações associadas a ele",
            ripple: true,
            dismissible: true,
          });
        } else {
          notyf.open({
            type: "danger",
            message: "Houve um erro, tente novamente",
            ripple: true,
            dismissible: true,
          });
        }
        console.log(error);
      });
  }

  function handleDelete(user_id) {
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <ShowConfirm
            title="Confirmar ação"
            description="Deseja remover esse usuário? Todas as customizações e eventos associados a ele serão excluídos."
            action={deleteUser}
            onClose={onClose}
            param={user_id}
          />
        );
      },
    });
  }

  function revokeSession(user_id, onSuccess) {
    setLoading(true);
    axios.post(`/api/user/${user_id}/session/revoke`)
      .then(function () {
        setLoading(false);
        notyf.open({
          type: "success",
          message: "Sessão encerrada. O usuário poderá entrar novamente.",
          ripple: true,
          dismissible: true,
        });
        if (onSuccess) onSuccess();
      })
      .catch(function (error) {
        setLoading(false);
        notyf.open({
          type: "danger",
          message: error.response?.data?.message || "Não foi possível encerrar a sessão.",
          ripple: true,
          dismissible: true,
        });
      });
  }

  function handleRevokeSession(user_id, onSuccess) {
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => (
        <ShowConfirm
          title="Encerrar sessão"
          description="Deseja encerrar a sessão ativa deste usuário?"
          action={(userId) => revokeSession(userId, onSuccess)}
          onClose={onClose}
          param={user_id}
        />
      ),
    });
  }

  useEffect(() => {
    const isInitialLoad = dataTable === false;
    setIsRefreshing(true);
    if (!isInitialLoad) setLoading(true);
    axios.get(`/api/user`)
      .then(function (response) {
        var users = response["data"]["message"];
        users.forEach(function callback(value, index) {
          value["icons"] = (
            <>
              <OverlayTrigger overlay={<Tooltip>Encerrar sessão ativa</Tooltip>}>
                <Unlock
                  role="button"
                  className="align-middle me-2 cursor-pointer"
                  onClick={() => {
                    handleRevokeSession(value["user_id"]);
                  }}
                  size={18}
                />
              </OverlayTrigger>
              <OverlayTrigger overlay={<Tooltip>Remover usuário</Tooltip>}>
                <Trash
                  role="button"
                  className="align-middle me-2 cursor-pointer"
                  onClick={() => {
                    handleDelete(value["user_id"]);
                  }}
                  size={18}
                />
              </OverlayTrigger>
              <OverlayTrigger overlay={<Tooltip>Editar usuário</Tooltip>}>
                <Edit
                  role="button"
                  className="align-middle me-0 cursor-pointer"
                  onClick={() => {
                    handleShow(value);
                  }}
                  size={18}
                />
              </OverlayTrigger>
            </>
          );
          switch (value["status"]) {
            case 0:
              value["statusString"] = "Inativo";
              break;
            case 1:
              value["statusString"] = "Ativo";
              break;
            default:
              break;
          }
          switch (value["tipo"]) {
            case 1:
              value["tipoString"] = "Administrador";
              break;
            case 2:
              value["tipoString"] = "Usuário";
              break;
            default:
              break;
          }
          if (value.plataforma_aplicativos === 0) {
            value.plataforma_aplicativosString = 'Apenas visualização'
          } else if (value.plataforma_aplicativos === 1) {
            value.plataforma_aplicativosString = 'Visualização com funções de relatório'
          } else if (value.plataforma_aplicativos === 2) {
            value.plataforma_aplicativosString = 'Criação e edição'
          }
          if (value.plataforma_eventos === 0) {
            value.plataforma_eventosString = 'Apenas visualização'
          } else if (value.plataforma_eventos === 1) {
            value.plataforma_eventosString = 'Visualização com funções de relatório'
          } else if (value.plataforma_eventos === 2) {
            value.plataforma_eventosString = 'Criação e edição'
          }
          if (value.aplicativos_customizacao === 0) {
            value.aplicativos_customizacaoString = 'Bloqueado'
          } else if (value.aplicativos_customizacao === 1) {
            value.aplicativos_customizacaoString = 'Criação e edição'
          }
        });
        if (!isInitialLoad) setLoading(false)
        setIsRefreshing(false);
        setDataTable(users);
      })
      .catch(function (error) {
        console.log(error);
        if (!isInitialLoad) setLoading(false);
        setIsRefreshing(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateDataTable]);

  //Loading icon
  if (tipo !== 1) {
    return <Navigate to="/" />;
  }

  if (dataTable === false || dataTable === undefined) {
    return <Loader></Loader>;
  }

  return (
    <Container fluid className="p-0 container">
      <Button
        type="button"
        variant="primary"
        className="btn update-side-panel-button"
        onClick={refreshUsers}
        disabled={isRefreshing}
        title="Atualizar usuários"
        aria-label="Atualizar usuários"
      >
        <FontAwesomeIcon icon={faSync} spin={isRefreshing} size="lg" />
      </Button>

      <Button
        variant="primary"
        className="float-end"
        onClick={() => {
          handleShow(false);
        }}
      ><FontAwesomeIcon icon={faPlus} size="1x" className="me-2" />
        Novo usuário
      </Button>
      <Button
        variant="primary"
        className="float-end me-2"
        onClick={handleShowSessions}
        disabled={isLoadingSessions}
      >
        Ver sessões
      </Button>
      <Breadcrumb>
        <Breadcrumb.Item active>
          Usuários
        </Breadcrumb.Item>
      </Breadcrumb>
      <h6 className="text-muted mb-0">
        Edite ou crie os usuários registrados no painel de controle
      </h6>
      <Row className="mt-3">
        <Col md={12}>
          <ColumnSortingTable
            columns={tableColumns}
            data={dataTable}
            getCellProps={(cellinfo) => ({
              className: cellinfo.column.id === "icons" ? "table-icons-triple" : "",
              style: {
                padding: cellinfo.column.id === "imagem" ? "0px 10px" : "",
                width: cellinfo.column.id === "imagem" ? "32px" : "",
              },
            })}
          />
          <ActiveSessionsModal
            show={showSessionsModal}
            onHide={handleCloseSessions}
            sessions={activeSessions}
            isLoading={isLoadingSessions}
            error={sessionsError}
            onRefresh={loadActiveSessions}
            onRevoke={(userId) => handleRevokeSession(userId, loadActiveSessions)}
          />
          <UserModal
            openModals={openModals}
            dataModal={dataModal}
            handleClose={handleClose}
            setDataTableUpdate={setDataTableUpdate}
          />
        </Col>
      </Row>
    </Container >
  );
};

const ActiveSessionsModal = ({ show, onHide, sessions, isLoading, error, onRefresh, onRevoke }) => (
  <Modal show={show} onHide={onHide} size="lg" centered>
    <Modal.Header closeButton>
      <Modal.Title>Sessões ativas</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {isLoading && (
        <div className="d-flex justify-content-center py-4">
          <Loader />
        </div>
      )}
      {!isLoading && error && (
        <div className="text-center text-danger py-5">
          <p className="mb-3">{error}</p>
          <Button size="sm" onClick={onRefresh}>Tentar novamente</Button>
        </div>
      )}
      {!isLoading && !error && sessions.length === 0 && (
        <div className="text-center text-muted py-4">Nenhuma sessão ativa.</div>
      )}
      {!isLoading && !error && sessions.length > 0 && (
        <div className="list-group">
          {sessions.map((session) => (
            <div key={session.user_id} className="list-group-item d-flex justify-content-between align-items-center gap-3">
              <div className="flex-grow-1">
                <div className="fw-semibold">{session.nome || "Usuário sem nome"}</div>
                <div className="text-muted small">{session.email || "E-mail indisponível"}</div>
                <div className="text-muted small">Último pulso: {formatSessionTimestamp(session.last_seen_at)}</div>
              </div>
              <Button
                type="button"
                variant="outline-danger"
                size="sm"
                onClick={() => onRevoke(session.user_id)}
              >
                Revogar
              </Button>
            </div>
          ))}
        </div>
      )}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide}>Fechar</Button>
      <Button variant="primary" onClick={onRefresh} disabled={isLoading}>
        <FontAwesomeIcon icon={faSync} spin={isLoading} className="me-2" />
        Atualizar
      </Button>
    </Modal.Footer>
  </Modal>
);

const nivelAcessoDescricoes = {
  0: "Apenas visualização — sem acesso a funções.",
  1: "Funções de relatório — permite adicionar/excluir participantes e resultados.",
  2: "Criação e edição de eventos.",
};

const UserModal = ({
  openModals,
  dataModal,
  handleClose,
  setDataTableUpdate
}) => {
  const { setLoading } = useLayout();
  const title = dataModal !== false ? "Editar usuário" : "Novo usuário";
  const dataModalIsAdmin = Number(dataModal?.tipo) === 1;
  const inicio_contrato_contaObj = new Date();
  const termino_contrato_contaObj = new Date();
  const inicio_contrato_conta = formatTz(inicio_contrato_contaObj, "dd/MM/yyyy HH:mm");
  const termino_contrato_contaObjX = add(termino_contrato_contaObj, { days: "60" });
  const termino_contrato_conta = formatTz(termino_contrato_contaObjX, "dd/MM/yyyy 12:00");
  const notyf = useContext(NotyfContext);
  const [isSendingPassword, setIsSendingPassword] = useState(false);
  const [sendPasswordCooldown, setSendPasswordCooldown] = useState(0);

  useEffect(() => {
    if (sendPasswordCooldown <= 0) return;
    const timer = setTimeout(() => setSendPasswordCooldown((c) => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [sendPasswordCooldown]);

  const sendPassword = () => {
    setIsSendingPassword(true);
    axios.post("/api/user/password-recovery", { email: dataModal.email })
      .then(() => {
        notyf.open({ type: "success", message: "E-mail com a senha foi enviado com sucesso", ripple: true, dismissible: true });
        setIsSendingPassword(false);
        setSendPasswordCooldown(60);
      })
      .catch((error) => {
        notyf.open({ type: "danger", message: error.response?.data?.message || "Erro ao enviar", ripple: true, dismissible: true });
        setIsSendingPassword(false);
      });
  };

  const handleSendPassword = () => {
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => (
        <ShowConfirm
          title="Confirmar ação"
          description="Deseja reenviar a senha para o e-mail do usuário?"
          action={sendPassword}
          onClose={onClose}
        />
      ),
    });
  };

  function createUser(values, actions) {
    setLoading(true)
    const data_criacaoObj = new Date();
    const date_criacao = formatTz(data_criacaoObj, "yyyy-MM-dd HH:mm");
    const isAdmin = Number(values.tipo) === 1;
    axios.post("/api/user", {
      nome: values.nome,
      email: values.email,
      tipo: values.tipo,
      status: values.status,
      data_criacao: date_criacao,
      plataforma_aplicativos: isAdmin ? 2 : values.plataforma_aplicativos,
      plataforma_eventos: isAdmin ? 2 : values.plataforma_eventos,
      aplicativos_customizacao: isAdmin ? 1 : values.aplicativos_customizacao,
      inicio_contrato_conta: values.inicio_contrato_conta,
      termino_contrato_conta: values.termino_contrato_conta,
    })
      .then(function (response) {
        handleClose();
        setDataTableUpdate((prevCount) => prevCount + 1);

        notyf.open({
          type: "success",
          message: "Conta criada com sucesso.",
          ripple: true,
          dismissible: true,
        });

        if (response.data?.emailError) {
          notyf.open({
            type: "warning",
            message: "A conta foi criada, mas o e-mail de acesso falhou ao ser enviado.",
            ripple: true,
            dismissible: true,
          });
        } else {
          notyf.open({
            type: "success",
            message: "E-mail com os dados de acesso enviado com sucesso.",
            ripple: true,
            dismissible: true,
          });
        }
      })
      .catch(function (error) {
        handleClose();
        notyf.open({
          type: "danger",
          message: "Houve um erro, tente novamente",
          ripple: true,
          dismissible: true,
        });
      });
  }

  function updateUser(values, actions) {
    setLoading(true)
    const isAdmin = Number(values.tipo) === 1;
    axios.put(`/api/user/${values.user_id}`, {
      nome: values.nome,
      email: values.email,
      senha: values.senha,
      tipo: values.tipo,
      status: values.status,
      plataforma_aplicativos: isAdmin ? 2 : values.plataforma_aplicativos,
      plataforma_eventos: isAdmin ? 2 : values.plataforma_eventos,
      aplicativos_customizacao: isAdmin ? 1 : values.aplicativos_customizacao,
      inicio_contrato_conta: values.inicio_contrato_conta,
      termino_contrato_conta: values.termino_contrato_conta,
    })
      .then(function (response) {
        handleClose();
        setDataTableUpdate((prevCount) => prevCount + 1);
      })
      .catch(function (error) {
        handleClose();
        notyf.open({
          type: "danger",
          message: "Houve um erro, tente novamente",
          ripple: true,
          dismissible: true,
        });
      });
  }

  return (
    <React.Fragment>
      <Modal show={openModals} onHide={handleClose} size="large" fullscreen={'sm-down'} centered>
        <Formik
          validationSchema={schema}
          onSubmit={dataModal !== false ? updateUser : createUser}
          enableReinitialize
          initialValues={{
            user_id: dataModal.user_id !== undefined ? dataModal.user_id : undefined,
            nome: dataModal.nome !== undefined ? dataModal.nome : "",
            email: dataModal.email !== undefined ? dataModal.email : "",
            senha: dataModal.senha !== undefined ? dataModal.senha : false,
            tipo: dataModal.tipo !== undefined ? dataModal.tipo : 2,
            status: dataModal.status !== undefined ? dataModal.status : 1,
            plataforma_aplicativos: dataModalIsAdmin ? 2 : dataModal.plataforma_aplicativos !== undefined ? dataModal.plataforma_aplicativos : 2,
            plataforma_eventos: dataModalIsAdmin ? 2 : dataModal.plataforma_eventos !== undefined ? dataModal.plataforma_eventos : 2,
            aplicativos_customizacao: dataModalIsAdmin ? 1 : dataModal.aplicativos_customizacao !== undefined ? dataModal.aplicativos_customizacao : 1,
            inicio_contrato_conta: dataModal.inicio_contrato_conta !== undefined ? convertDateToDisplay(dataModal.inicio_contrato_conta) : inicio_contrato_conta,
            termino_contrato_conta: dataModal.termino_contrato_conta !== undefined ? convertDateToDisplay(dataModal.termino_contrato_conta) : termino_contrato_conta,
          }}
        >
          {({
            handleSubmit,
            handleChange,
            validateForm,
            values,
            touched,
            isValid,
            errors,
            dirty,
            isSubmitting,
            setFieldValue,
          }) => {
            const isAdmin = Number(values.tipo) === 1;

            const handleUserTypeChange = (event) => {
              const tipo = parseInt(event.target.value, 10);
              setFieldValue("tipo", tipo);

              if (tipo === 1) {
                setFieldValue("plataforma_aplicativos", 2);
                setFieldValue("plataforma_eventos", 2);
                setFieldValue("aplicativos_customizacao", 1);
              }
            };

            return (
              <Form noValidate onSubmit={async (e) => {
              e.preventDefault();
              const validationErrors = await validateForm();
              const firstErrorField = Object.keys(validationErrors)[0];
              if (firstErrorField) {
                const errorElement = document.querySelector(
                  `[name="${firstErrorField}"]`
                );
                if (errorElement) {
                  errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
                  errorElement.focus();
                }
                notyf.open({
                  type: "error",
                  message: "Existem campos inválidos no formulário",
                  ripple: true,
                  dismissible: true,
                });
              } else {
                handleSubmit();
              }
            }}>
              <Modal.Header closeButton>{title}</Modal.Header>
              <Modal.Body>
                <Row>
                  <Form.Group as={Col} md="12">
                    <Form.Control
                      type="hidden"
                      name="user_id"
                      value={values.user_id}
                      onChange={handleChange}
                    />
                  </Form.Group>
                  <Form.Group as={Col} md="12" className="mb-3">
                    <Form.Label>Nome</Form.Label>
                    <Form.Control
                      type="text"
                      name="nome"
                      value={values.nome}
                      onChange={handleChange}
                      isInvalid={!!errors.nome}
                      isValid={touched.nome && !errors.nome}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      {errors.nome}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} md="6" className="mb-3">
                    <Form.Label>E-mail</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      onChange={(e) => {
                        if (!values.user_id > 0) {
                          setFieldValue("email", e.target.value);
                        }
                      }}
                      autoComplete="new-password"
                      value={values.email}
                      className={values.user_id > 0 ? "disableInput" : ""}
                      isInvalid={!!errors.email}
                      isValid={touched.email && !errors.email}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      {errors.email}
                    </Form.Control.Feedback>
                  </Form.Group>
                  {values.senha && <Form.Group
                    className="mb-3"
                    as={Col}
                    md="6">
                    <Form.Label>Senha</Form.Label>
                    <Form.Control
                      type="text"
                      name="senha"
                      autoComplete="new-password"
                      value={values.senha}
                      onChange={handleChange}
                      isInvalid={!!errors.senha}
                      isValid={touched.senha && !errors.senha}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      {errors.senha}
                    </Form.Control.Feedback>
                  </Form.Group>}
                </Row>
                <Row className="mb-3">
                  <Form.Group as={Col} md="6"
                    className="mb-3">
                    <Form.Label>Status</Form.Label>
                    <Form.Select
                      name="status"
                      value={values.status}
                      onChange={handleChange}
                      isInvalid={!!errors.status}
                      isValid={!!errors.status}
                    >
                      <option value="1">Ativo</option>
                      <option value="0">Inativo</option>
                    </Form.Select>
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      {errors.status}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="6"
                    className="mb-3">
                    <Form.Label>Tipo de acesso</Form.Label>
                    <Form.Select
                      name="tipo"
                      value={values.tipo}
                      onChange={handleUserTypeChange}
                      isInvalid={!!errors.tipo}
                      isValid={!!errors.tipo}
                    >
                      <option value="2">Usuário</option>
                      <option value="1">Administrador</option>
                    </Form.Select>
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      {errors.tipo}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <p className="text-start fw-bold mb-2">Tempo de vigência</p>
                  <Form.Group
                    className="mb-3"
                    as={Col}
                    sm={6}

                  >
                    <Form.Label>Data de ínicio</Form.Label>
                    <div className={`position-relative ${errors.inicio_contrato_conta ? 'is-invalid' : touched.inicio_contrato_conta && !errors.inicio_contrato_conta ? 'is-valid' : ''}`}>
                      <Datetime
                        value={values.inicio_contrato_conta}
                        onChange={(date) => {
                          if (date && typeof date === 'object' && date._isValid !== false) {
                            const formattedDate = format(new Date(date), 'dd/MM/yyyy HH:mm');
                            setFieldValue('inicio_contrato_conta', formattedDate);
                          } else {
                            setFieldValue('inicio_contrato_conta', typeof date === 'string' ? date : '');
                          }
                        }}
                        dateFormat="DD/MM/YYYY"
                        timeFormat="HH:mm"
                        inputProps={{
                          placeholder: 'dd/MM/yyyy HH:mm',
                          className: `form-control ${errors.inicio_contrato_conta ? 'is-invalid' :
                            touched.inicio_contrato_conta && !errors.inicio_contrato_conta ? 'is-valid' : ''
                            }`
                        }}
                        locale="pt-br"
                      />
                    </div>
                    {touched.inicio_contrato_conta && !errors.inicio_contrato_conta && (
                      <div className="valid-feedback d-block"></div>
                    )}
                    {errors.inicio_contrato_conta && (
                      <div className="invalid-feedback d-block">
                        {errors.inicio_contrato_conta}
                      </div>
                    )}
                  </Form.Group>
                  <Form.Group
                    className="mb-3"
                    as={Col}
                    sm={6}

                  >
                    <Form.Label>Data de término</Form.Label>
                    <div className={`position-relative ${errors.termino_contrato_conta ? 'is-invalid' : touched.termino_contrato_conta && !errors.termino_contrato_conta ? 'is-valid' : ''}`}>
                      <Datetime
                        value={values.termino_contrato_conta}
                        onChange={(date) => {
                          if (date && typeof date === 'object' && date._isValid !== false) {
                            const formattedDate = format(new Date(date), 'dd/MM/yyyy HH:mm');
                            setFieldValue('termino_contrato_conta', formattedDate);
                          } else {
                            setFieldValue('termino_contrato_conta', typeof date === 'string' ? date : '');
                          }
                        }}
                        dateFormat="DD/MM/YYYY"
                        timeFormat="HH:mm"
                        inputProps={{
                          placeholder: 'dd/MM/yyyy HH:mm',
                          className: `form-control ${errors.termino_contrato_conta ? 'is-invalid' :
                            touched.termino_contrato_conta && !errors.termino_contrato_conta ? 'is-valid' : ''
                            }`
                        }}
                        locale="pt-br"
                        isValidDate={(current) => {
                          // Only allow dates >= inicio_contrato_conta if inicio_contrato_conta is set
                          if (values.inicio_contrato_conta) {
                            try {
                              const startDate = parse(values.inicio_contrato_conta, 'dd/MM/yyyy HH:mm', new Date());
                              if (isValidDateFns(startDate)) {
                                return current.toDate() >= startDate;
                              }
                            } catch {
                              return true;
                            }
                          }
                          return true;
                        }}
                      />
                    </div>
                    {touched.termino_contrato_conta && !errors.termino_contrato_conta && (
                      <div className="valid-feedback d-block"></div>
                    )}
                    {errors.termino_contrato_conta && (
                      <div className="invalid-feedback d-block">
                        {errors.termino_contrato_conta}
                      </div>
                    )}
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <p className="text-start fw-bold mb-2">Plataforma de aplicativos</p>
                  <Form.Group className="mb-3">
                    <Form.Label>Nível de acesso</Form.Label>
                    <Form.Select
                      name="plataforma_aplicativos"
                      value={values.plataforma_aplicativos}
                      disabled={isAdmin}
                      onChange={(e) => setFieldValue("plataforma_aplicativos", parseInt(e.target.value))}
                    >
                      <option value={0}>Apenas visualização</option>
                      <option value={1}>Visualização com funções de relatório</option>
                      <option value={2}>Criação e edição</option>
                    </Form.Select>
                    <Form.Text className="text-muted">{nivelAcessoDescricoes[values.plataforma_aplicativos]}</Form.Text>
                    <Form.Check
                      className="w-auto mt-2 mb-0"
                      checked={values.aplicativos_customizacao === 1 ? true : false}
                      disabled={isAdmin}
                      type="checkbox"
                      name="aplicativos_customizacao"
                      label={<>Customização de aplicativos <OverlayTrigger overlay={<Tooltip>Libera o acesso a página de customizações, onde o usuário pode criar e editar customizações dos aplicativos da plataforma de aplicativos</Tooltip>}>
                        <HelpTooltip icon={faExclamationCircle} />
                      </OverlayTrigger></>}
                      onChange={(e) => {
                        setFieldValue(
                          "aplicativos_customizacao",
                          values.aplicativos_customizacao === 1 ? 0 : 1
                        );
                      }}
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className="mb-3">
                    <p className="text-start fw-bold mb-2">Plataforma de eventos</p>
                    <Form.Label>Nível de acesso</Form.Label>
                    <Form.Select
                      name="plataforma_eventos"
                      value={values.plataforma_eventos}
                      disabled={isAdmin}
                      onChange={(e) => setFieldValue("plataforma_eventos", parseInt(e.target.value))}
                    >
                      <option value={0}>Apenas visualização</option>
                      <option value={1}>Visualização com funções de relatório</option>
                      <option value={2}>Criação e edição</option>
                    </Form.Select>
                    <Form.Text className="text-muted">{nivelAcessoDescricoes[values.plataforma_eventos]}</Form.Text>
                  </Form.Group>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                {dataModal !== false && (
                  <Button variant="secondary" onClick={handleSendPassword} disabled={isSendingPassword || sendPasswordCooldown > 0}>
                    {isSendingPassword ? "Enviando..." : sendPasswordCooldown > 0 ? `Reenviar senha (${sendPasswordCooldown}s)` : "Reenviar senha"}
                  </Button>
                )}
                <Button type="submit" disabled={!dirty || isSubmitting}>
                  Salvar
                </Button>
              </Modal.Footer>
              </Form>
            );
          }}
        </Formik>
      </Modal>
    </React.Fragment>
  );
};

export default TableUsers;
